import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CurrencyProp from '../../../profile/propTypes/currencyProp';
import { newFormatPrice } from '../../../../services/utilityFunctions';
import CheckIcon from '../../../../commonComponents/icons/CheckIcon';
import CrossIcon from '../../../../commonComponents/icons/CrossIcon';

function FastBonusCard(props) {
  const { t, index, bonusData, bonusDescription } = props;

  const { commission, daysRemaining, bonusAchieved, currencyInfo } = bonusData;

  const renderIcon = () => {
    if (bonusAchieved) {
      return <CheckIcon color="#3FBC5F" />;
    }
    if (!bonusAchieved && daysRemaining > 0) {
      return <div className="empty-circle" />;
    }
    if (!bonusAchieved && daysRemaining <= 0) {
      return <CrossIcon color="#3FBC5F" />;
    }
    return null;
  };

  return (
    <div className="card fast-bonus-card">
      <div className="fast-bonus-card-header">
        <span>{t(`report.laborigin.fastStartBonus${index + 1}`)}</span>
        <div className="fast-bonus-end-container">
          <div className="fast-bonus-price">
            {newFormatPrice(commission, false, 'EUR')}
          </div>
          <div className="completedStageCheck">{renderIcon()}</div>
        </div>
      </div>
      {daysRemaining && daysRemaining > 0 ? (
        <div className="fast-bonus-days-remaining">{`${daysRemaining} ${t(
          'report.neofin.fastBonus.daysRemaining',
        )}`}</div>
      ) : null}
      <div className="fast-bonus-card-body">{bonusDescription}</div>
    </div>
  );
}

FastBonusCard.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  bonusDescription: PropTypes.string.isRequired,
  bonusData: PropTypes.shape({
    commission: PropTypes.number,
    daysRemaining: PropTypes.number,
    bonusAchieved: PropTypes.number,
    currencyInfo: PropTypes.shape(CurrencyProp.propType),
  }).isRequired,
};

export default translate(FastBonusCard);
